import { Phrases } from './phrases';
import { IconGlyph } from '../../components/Icon';

export const SUBJECT_GROUP_INPUT_TAGS: Record<string, string[]> = {
  'Mathematics & Statistics': [
    Phrases.INPUT_TAG_SIMPLIFY_EXPLANATION_MATH,
    Phrases.INPUT_TAG_FOCUS_ON_KEY_STEPS_MATH,
    Phrases.INPUT_TAG_REDERIVE_THE_RESULT,
    Phrases.INPUT_TAG_ALTERNATIVE_METHOD,
    Phrases.INPUT_TAG_VALIDATE_AGAINST_THE_QUESTION,
    Phrases.INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_MATH,
  ],
  'Computer Science & Tech': [
    Phrases.INPUT_TAG_EXPLAIN_THE_LOGIC_SIMPLER,
    Phrases.INPUT_TAG_FOCUS_ON_THE_CORE_ALGORITHM,
    Phrases.INPUT_TAG_ALTERNATIVE_APPROACH,
    Phrases.INPUT_TAG_RECHECK_EDGE_CASES,
    Phrases.INPUT_TAG_SHORTER_EXPLANATION,
  ],
  'Natural Sciences': [
    Phrases.INPUT_TAG_SIMPLIFY_EXPLANATION_NATURAL_SCIENCES,
    Phrases.INPUT_TAG_ADD_DEFINITIONS,
    Phrases.INPUT_TAG_ADD_EXAMPLES_NATURAL_SCIENCES,
    Phrases.INPUT_TAG_COMPARE_WITH_A_SIMILAR_CONCEPT,
    Phrases.INPUT_TAG_FOCUS_ON_KEY_MECHANISM,
  ],
  'Engineering & Architecture': [
    Phrases.INPUT_TAG_CLARIFY_ASSUMPTIONS,
    Phrases.INPUT_TAG_FOCUS_ON_CALCULATIONS,
    Phrases.INPUT_TAG_EXPLAIN_DESIGN_LOGIC,
    Phrases.INPUT_TAG_ALTERNATIVE_DESIGN_APPROACH,
    Phrases.INPUT_TAG_CONCISE_ENGINEERING_ANSWER,
  ],
  'Business & Management': [
    Phrases.INPUT_TAG_IMPROVE_STRUCTURE_BUSINESS,
    Phrases.INPUT_TAG_MAKE_IT_MORE_PROFESSIONAL,
    Phrases.INPUT_TAG_FOCUS_ON_RECOMMENDATIONS,
    Phrases.INPUT_TAG_SHORT_EXECUTIVE_STYLE_ANSWER,
    Phrases.INPUT_TAG_ADD_PRACTICAL_EXAMPLE,
  ],
  'Economics & Finance': [
    Phrases.INPUT_TAG_CLARIFY_ECONOMIC_INTUITION_ECONOMICS,
    Phrases.INPUT_TAG_FOCUS_ON_KEY_STEPS_ECONOMICS,
    Phrases.INPUT_TAG_VALIDATE_CALCULATIONS_ECONOMICS,
    Phrases.INPUT_TAG_ALTERNATIVE_INTERPRETATION_ECONOMICS,
    Phrases.INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_ECONOMICS,
  ],
  'Economics & Finance (Accounting)': [
    Phrases.INPUT_TAG_CLARIFY_ECONOMIC_INTUITION_ACCOUNTING,
    Phrases.INPUT_TAG_FOCUS_ON_KEY_STEPS_ACCOUNTING,
    Phrases.INPUT_TAG_VALIDATE_CALCULATIONS_ACCOUNTING,
    Phrases.INPUT_TAG_ALTERNATIVE_INTERPRETATION_ACCOUNTING,
    Phrases.INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_ACCOUNTING,
  ],
  'Social Sciences & Law': [
    Phrases.INPUT_TAG_IMPROVE_LOGICAL_FLOW,
    Phrases.INPUT_TAG_CLARIFY_MAIN_ARGUMENT,
    Phrases.INPUT_TAG_ADD_COUNTERPOINT_EXPLANATION,
    Phrases.INPUT_TAG_FOCUS_ON_THEORY_APPLICATION,
    Phrases.INPUT_TAG_SHORT_ANALYTICAL_SUMMARY,
  ],
  'Health & Nursing': [
    Phrases.INPUT_TAG_CLARIFY_CARE_PRIORITIES,
    Phrases.INPUT_TAG_SIMPLIFY_MEDICAL_LANGUAGE,
    Phrases.INPUT_TAG_FOCUS_ON_ASSESSMENT_STEPS,
    Phrases.INPUT_TAG_CONCISE_EXAM_STYLE_ANSWER_HEALTH,
  ],
  'Humanities & Languages': [
    Phrases.INPUT_TAG_IMPROVE_STRUCTURE_HUMANITIES,
    Phrases.INPUT_TAG_CLARIFY_THESIS,
    Phrases.INPUT_TAG_MAKE_IT_MORE_FORMAL,
    Phrases.INPUT_TAG_ADD_EXAMPLES_HUMANITIES,
    Phrases.INPUT_TAG_SHORTER_ANALYTICAL_VERSION,
  ],
  Other: [
    Phrases.INPUT_TAG_SIMPLIFY_EXPLANATION_OTHER,
    Phrases.INPUT_TAG_ADD_EXAMPLES_OTHER,
    Phrases.INPUT_TAG_FOCUS_ON_KEY_IDEA,
    Phrases.INPUT_TAG_SHORT_SUMMARY,
  ],
};

export const DEFAULT_SUBJECT_GROUP_INPUT_TAGS = SUBJECT_GROUP_INPUT_TAGS.Other;

export const SUBJECT_GROUP_FEATURE_BANNER_PHRASES: Record<
  string,
  { text: string; cta: string }
> = {
  'Mathematics & Statistics': {
    text: Phrases.FEATURE_BANNER_MATH_TEXT,
    cta: Phrases.FEATURE_BANNER_MATH_CTA,
  },
  'Computer Science & Tech': {
    text: Phrases.FEATURE_BANNER_COMPUTER_SCIENCE_TEXT,
    cta: Phrases.FEATURE_BANNER_COMPUTER_SCIENCE_CTA,
  },
  'Natural Sciences': {
    text: Phrases.FEATURE_BANNER_NATURAL_SCIENCES_TEXT,
    cta: Phrases.FEATURE_BANNER_NATURAL_SCIENCES_CTA,
  },
  'Engineering & Architecture': {
    text: Phrases.FEATURE_BANNER_ENGINEERING_TEXT,
    cta: Phrases.FEATURE_BANNER_ENGINEERING_CTA,
  },
  'Business & Management': {
    text: Phrases.FEATURE_BANNER_BUSINESS_TEXT,
    cta: Phrases.FEATURE_BANNER_BUSINESS_CTA,
  },
  'Economics & Finance': {
    text: Phrases.FEATURE_BANNER_ECONOMICS_TEXT,
    cta: Phrases.FEATURE_BANNER_ECONOMICS_CTA,
  },
  'Economics & Finance (Accounting)': {
    text: Phrases.FEATURE_BANNER_ACCOUNTING_TEXT,
    cta: Phrases.FEATURE_BANNER_ACCOUNTING_CTA,
  },
  'Social Sciences & Law': {
    text: Phrases.FEATURE_BANNER_SOCIAL_SCIENCES_TEXT,
    cta: Phrases.FEATURE_BANNER_SOCIAL_SCIENCES_CTA,
  },
  'Health & Nursing': {
    text: Phrases.FEATURE_BANNER_HEALTH_TEXT,
    cta: Phrases.FEATURE_BANNER_HEALTH_CTA,
  },
  'Humanities & Languages': {
    text: Phrases.FEATURE_BANNER_HUMANITIES_TEXT,
    cta: Phrases.FEATURE_BANNER_HUMANITIES_CTA,
  },
  Other: {
    text: Phrases.FEATURE_BANNER_OTHER_TEXT,
    cta: Phrases.FEATURE_BANNER_OTHER_CTA,
  },
} as const;

export const DEFAULT_SUBJECT_GROUP_FEATURE_BANNER_PHRASE =
  SUBJECT_GROUP_FEATURE_BANNER_PHRASES.Other;

export const SUBJECT_GROUP_SOLUTION_TOOLS: Record<
  string,
  Array<{ name: string; icon: IconGlyph; url: string }>
> = {
  'Mathematics & Statistics': [
    {
      name: Phrases.SOLUTION_TOOL_GENERATE_PRACTICE_PROBLEMS,
      icon: IconGlyph.CHECKLIST_NOTE,
      url: 'math-ai',
    },
    {
      name: Phrases.SOLUTION_TOOL_MAKE_A_GRAPH_PLOT,
      icon: IconGlyph.GRAPH,
      url: 'ai-pie-chart-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_CREATE_A_CALCULATION_TABLE,
      icon: IconGlyph.CALCULATOR,
      url: 'statistics-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_FORMULA_CHEAT_SHEET_MATH,
      icon: IconGlyph.DOCUMENTS,
      url: 'math-ai',
    },
    {
      name: Phrases.SOLUTION_TOOL_QUIZ_ME_MATH,
      icon: IconGlyph.QUESTION,
      url: 'ai-quiz-generator',
    },
  ],
  'Computer Science & Tech': [
    {
      name: Phrases.SOLUTION_TOOL_GENERATE_RUNNABLE_CODE,
      icon: IconGlyph.TAB,
      url: 'python-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_ADD_TEST_CASES,
      icon: IconGlyph.CHECKLIST,
      url: 'computer-science-homework',
    },
    {
      name: Phrases.SOLUTION_TOOL_EXPLAIN_TIME_SPACE_COMPLEXITY,
      icon: IconGlyph.TIME,
      url: 'computer-science-homework',
    },
    {
      name: Phrases.SOLUTION_TOOL_DEBUG_THIS_LOGIC,
      icon: IconGlyph.BRAIN,
      url: 'computer-science-homework',
    },
    {
      name: Phrases.SOLUTION_TOOL_REFACTOR_FOR_CLARITY,
      icon: IconGlyph.PUZZLE,
      url: 'computer-science-homework',
    },
  ],
  'Natural Sciences': [
    {
      name: Phrases.SOLUTION_TOOL_GENERATE_FLASHCARDS,
      icon: IconGlyph.NOTES,
      url: 'ai-flashcard-maker',
    },
    {
      name: Phrases.SOLUTION_TOOL_CREATE_SUMMARY_NOTES_NATURAL_SCIENCES,
      icon: IconGlyph.MULTI_NOTES,
      url: 'ai-lecture-note-taker',
    },
    {
      name: Phrases.SOLUTION_TOOL_QUIZ_ME_NATURAL_SCIENCES,
      icon: IconGlyph.QUESTION,
      url: 'ai-quiz-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_KEY_TERMS_CHEAT_SHEET,
      icon: IconGlyph.NOTE_WITH_PEN,
      url: 'ai-notes-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_QUESTIONS_NATURAL_SCIENCES,
      icon: IconGlyph.QUESTIONS,
      url: 'math-ai',
    },
  ],
  'Engineering & Architecture': [
    {
      name: Phrases.SOLUTION_TOOL_CREATE_A_DIAGRAM,
      icon: IconGlyph.DIAGRAM,
      url: 'ai-diagram-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_ENGINEERING_CHECKLIST,
      icon: IconGlyph.NOTE_LIST,
      url: 'physics-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_DESIGN_VERIFICATION_STEPS,
      icon: IconGlyph.TASKS,
      url: 'physics-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_UNITS_CONSTRAINTS_CHECKLIST,
      icon: IconGlyph.NOTE_SUC,
      url: 'physics-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_ENGINEERING_PROBLEMS,
      icon: IconGlyph.SETTING,
      url: 'physics-homework-help',
    },
  ],
  'Business & Management': [
    {
      name: Phrases.SOLUTION_TOOL_EXECUTIVE_SUMMARY,
      icon: IconGlyph.NOTE_GRAPH,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_SWOT_PESTLE_ANALYSIS,
      icon: IconGlyph.CROSS_PLUS,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_ACTION_PLAN,
      icon: IconGlyph.DARTS,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_COMPARISON_TABLE,
      icon: IconGlyph.SCALE_IDEA,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_PRESENTATION_OUTLINE,
      icon: IconGlyph.PAINT,
      url: 'ai-powerpoint-generator',
    },
  ],
  'Economics & Finance': [
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_EXAM_QUESTIONS_ECONOMICS,
      icon: IconGlyph.CHECKLIST_PEN,
      url: 'math-ai',
    },
    {
      name: Phrases.SOLUTION_TOOL_CALCULATION_TEMPLATES_ECONOMICS,
      icon: IconGlyph.CALCULATOR,
      url: 'statistics-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_FORMULA_CHEAT_SHEET_ECONOMICS,
      icon: IconGlyph.DOCUMENTS,
      url: 'math-ai',
    },
    {
      name: Phrases.SOLUTION_TOOL_GRAPH_TRENDS_SUPPLY_DEMAND_ECONOMICS,
      icon: IconGlyph.STONKS,
      url: 'economics-ai-homework-help',
    },
  ],
  'Economics & Finance (Accounting)': [
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_EXAM_QUESTIONS_ACCOUNTING,
      icon: IconGlyph.CHECKLIST_PEN,
      url: 'accounting-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_CALCULATION_TEMPLATES_ACCOUNTING,
      icon: IconGlyph.CALCULATOR,
      url: 'accounting-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_FORMULA_CHEAT_SHEET_ACCOUNTING,
      icon: IconGlyph.DOCUMENTS,
      url: 'math-ai',
    },
    {
      name: Phrases.SOLUTION_TOOL_GRAPH_TRENDS_SUPPLY_DEMAND_ACCOUNTING,
      icon: IconGlyph.STONKS,
      url: 'economics-ai-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_JOURNAL_ENTRY_TEMPLATES,
      icon: IconGlyph.BOOK_PEN,
      url: 'accounting-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_T_ACCOUNTS_BUILDER,
      icon: IconGlyph.TREE,
      url: 'accounting-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_FINANCIAL_STATEMENTS_FORMAT,
      icon: IconGlyph.ATOM,
      url: 'accounting-homework-help',
    },
  ],
  'Social Sciences & Law': [
    {
      name: Phrases.SOLUTION_TOOL_IRAC_TEMPLATE_LAW,
      icon: IconGlyph.SCALE,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_ARGUMENT_OUTLINE,
      icon: IconGlyph.CONVO,
      url: 'philosophy-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_COUNTERARGUMENTS_BUILDER,
      icon: IconGlyph.PENS,
      url: 'philosophy-homework-help',
    },
    {
      name: Phrases.SOLUTION_TOOL_CASE_STYLE_PRACTICE_QUESTIONS,
      icon: IconGlyph.IDEA,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_STUDY_NOTES_SOCIAL_SCIENCES,
      icon: IconGlyph.CALENDAR,
      url: 'ai-lecture-note-taker',
    },
  ],
  'Health & Nursing': [
    {
      name: Phrases.SOLUTION_TOOL_CARE_PLAN_TEMPLATE,
      icon: IconGlyph.DOCUMENT,
      url: 'biology-problem-solver',
    },
    {
      name: Phrases.SOLUTION_TOOL_ASSESSMENT_CHECKLIST,
      icon: IconGlyph.CHECKLIST_SUC_DEC,
      url: 'biology-problem-solver',
    },
    {
      name: Phrases.SOLUTION_TOOL_PATIENT_EDUCATION_SCRIPT,
      icon: IconGlyph.PERSON_PLUS,
      url: 'biology-problem-solver',
    },
    {
      name: Phrases.SOLUTION_TOOL_NCLEX_STYLE_QUESTIONS,
      icon: IconGlyph.MED_DOC,
      url: 'ai-quiz-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_STUDY_NOTES_HEALTH,
      icon: IconGlyph.CALENDAR,
      url: 'ai-lecture-note-taker',
    },
  ],
  'Humanities & Languages': [
    {
      name: Phrases.SOLUTION_TOOL_ESSAY_OUTLINE,
      icon: IconGlyph.NOTE_TEXT,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_THESIS_BUILDER,
      icon: IconGlyph.HAT,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_EVIDENCE_EXAMPLES_BANK,
      icon: IconGlyph.BOOK,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_ADD_CITATIONS,
      icon: IconGlyph.QUOTE,
      url: 'ai-research-assistant',
    },
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_ESSAY_QUESTIONS,
      icon: IconGlyph.CHECKLIST_PEN,
      url: 'ai-quiz-generator',
    },
  ],
  Other: [
    {
      name: Phrases.SOLUTION_TOOL_SUMMARY_NOTES_OTHER,
      icon: IconGlyph.MULTI_NOTES,
      url: 'ai-notes-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_QUIZ_ME_OTHER,
      icon: IconGlyph.QUESTION,
      url: 'ai-quiz-generator',
    },
    {
      name: Phrases.SOLUTION_TOOL_PRACTICE_QUESTIONS_OTHER,
      icon: IconGlyph.QUESTIONS,
      url: 'math-ai',
    },
  ],
};

export const DEFAULT_SUBJECT_GROUP_SOLUTION_TOOLS =
  SUBJECT_GROUP_SOLUTION_TOOLS.Other;
